import apiClient from './apiClient';
import { ApplicationLog } from '../types/ApplicationLog';

const api = apiClient;

export const logApi = {
  getLogs: async (
    pageSize: number = 100,
    pageNumber: number = 1,
    level?: string,
    fromDate?: Date,
    toDate?: Date,
    application?: string,
    messageStartsWith?: string
  ): Promise<ApplicationLog[]> => {
    const params = new URLSearchParams();
    params.append('pageSize', pageSize.toString());
    params.append('pageNumber', pageNumber.toString());
    if (level) params.append('level', level);
    if (fromDate) params.append('fromDate', fromDate.toISOString());
    if (toDate) params.append('toDate', toDate.toISOString());
    if (application) params.append('application', application);
    if (messageStartsWith) params.append('messageStartsWith', messageStartsWith);

    const response = await api.get(`/api/applicationlogs?${params.toString()}`);
    return response.data;
  },

  getLogCount: async (
    level?: string,
    fromDate?: Date,
    toDate?: Date,
    application?: string,
    messageStartsWith?: string
  ): Promise<number> => {
    const params = new URLSearchParams();
    if (level) params.append('level', level);
    if (fromDate) params.append('fromDate', fromDate.toISOString());
    if (toDate) params.append('toDate', toDate.toISOString());
    if (application) params.append('application', application);
    if (messageStartsWith) params.append('messageStartsWith', messageStartsWith);

    const response = await api.get(`/api/applicationlogs/count?${params.toString()}`);
    return response.data;
  },

  clearLogs: async (beforeDate?: Date): Promise<void> => {
    const params = beforeDate ? `?beforeDate=${beforeDate.toISOString()}` : '';
    await api.delete(`/api/applicationlogs/clear${params}`);
  },
};